import Vue from 'vue';
import Router from 'vue-router';
import constantRoutes from './constantRoutes';
Vue.use(Router);
// 创建Router
var createRouter = function createRouter() {
  return new Router({
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

// 获取原型对象上的push函数 修改原型对象中的push方法
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
export default router;